var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "q-form",
        { ref: "editForm" },
        [
          _c(
            "c-card",
            {
              staticClass: "cardClassDetailForm",
              attrs: { title: "평가계획 기본정보" },
            },
            [
              _c("template", { slot: "card-detail" }, [
                _c(
                  "div",
                  {
                    staticClass: "col-12",
                    staticStyle: { "margin-top": "5px" },
                  },
                  [
                    _c("c-text", {
                      attrs: {
                        required: true,
                        editable: _vm.editable,
                        disabled: true,
                        label: "평가명",
                        name: "assessmentName",
                      },
                      model: {
                        value: _vm.assessPlan.assessmentName,
                        callback: function ($$v) {
                          _vm.$set(_vm.assessPlan, "assessmentName", $$v)
                        },
                        expression: "assessPlan.assessmentName",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "col-12" },
                  [
                    _c("c-datepicker", {
                      attrs: {
                        required: true,
                        editable: _vm.editable,
                        disabled: true,
                        range: true,
                        label: "평가기간",
                        name: "period",
                      },
                      model: {
                        value: _vm.assessPlan.assessmentPeriod,
                        callback: function ($$v) {
                          _vm.$set(_vm.assessPlan, "assessmentPeriod", $$v)
                        },
                        expression: "assessPlan.assessmentPeriod",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "col-6" },
                  [
                    _c("c-select", {
                      attrs: {
                        required: true,
                        editable: _vm.editable,
                        disabled: true,
                        codeGroupCd: "RAM_ASSESS_TYPE_CD",
                        type: "edit",
                        itemText: "codeName",
                        itemValue: "code",
                        name: "ramAssessTypeCd",
                        label: "평가구분-정기/수시/최초",
                      },
                      model: {
                        value: _vm.assessPlan.ramAssessTypeCd,
                        callback: function ($$v) {
                          _vm.$set(_vm.assessPlan, "ramAssessTypeCd", $$v)
                        },
                        expression: "assessPlan.ramAssessTypeCd",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "col-6" },
                  [
                    _c("c-select", {
                      attrs: {
                        required: true,
                        editable: _vm.editable,
                        disabled: true,
                        comboItems: _vm.matrixItems,
                        type: "edit",
                        itemText: "matrixName",
                        itemValue: "ramMatrixId",
                        name: "ramMatrixId",
                        label: "Matrix",
                      },
                      model: {
                        value: _vm.assessPlan.ramMatrixId,
                        callback: function ($$v) {
                          _vm.$set(_vm.assessPlan, "ramMatrixId", $$v)
                        },
                        expression: "assessPlan.ramMatrixId",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "col-6" },
                  [
                    _c("c-plant", {
                      attrs: {
                        required: true,
                        disabled: true,
                        editable: _vm.editable,
                        type: "edit",
                        name: "plantCd",
                      },
                      model: {
                        value: _vm.assessPlan.plantCd,
                        callback: function ($$v) {
                          _vm.$set(_vm.assessPlan, "plantCd", $$v)
                        },
                        expression: "assessPlan.plantCd",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "col-6" },
                  [
                    _c("c-dept", {
                      attrs: {
                        required: true,
                        editable: _vm.editable,
                        disabled: true,
                        type: "edit",
                        label: "진행부서",
                        name: "assessmentManageDeptCd",
                        isFirstValue: false,
                      },
                      model: {
                        value: _vm.assessPlan.assessmentManageDeptCd,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.assessPlan,
                            "assessmentManageDeptCd",
                            $$v
                          )
                        },
                        expression: "assessPlan.assessmentManageDeptCd",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "col-6" },
                  [
                    _c("c-text", {
                      attrs: {
                        editable: _vm.editable,
                        disabled: true,
                        label: "작성자/작성일",
                        name: "request",
                      },
                      model: {
                        value: _vm.request,
                        callback: function ($$v) {
                          _vm.request = $$v
                        },
                        expression: "request",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "col-6" },
                  [
                    _c("c-vendor", {
                      attrs: {
                        disabled: true,
                        editable: _vm.editable,
                        label: "외부기관(업체)",
                        name: "vendorCd",
                      },
                      model: {
                        value: _vm.assessPlan.vendorCd,
                        callback: function ($$v) {
                          _vm.$set(_vm.assessPlan, "vendorCd", $$v)
                        },
                        expression: "assessPlan.vendorCd",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "col-6" },
                  [
                    _c("c-field", {
                      attrs: {
                        required: true,
                        editable: _vm.editable,
                        disabled: true,
                        data: _vm.assessPlan,
                        type: "user",
                        label: "평가팀 리더",
                        name: "reviewUserId",
                      },
                      model: {
                        value: _vm.assessPlan.reviewUserId,
                        callback: function ($$v) {
                          _vm.$set(_vm.assessPlan, "reviewUserId", $$v)
                        },
                        expression: "assessPlan.reviewUserId",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "col-6" },
                  [
                    _c("c-field", {
                      attrs: {
                        required: true,
                        editable: _vm.editable,
                        disabled: true,
                        data: _vm.assessPlan,
                        type: "user",
                        label: "평가자",
                        name: "approvalUserId",
                      },
                      model: {
                        value: _vm.assessPlan.approvalUserId,
                        callback: function ($$v) {
                          _vm.$set(_vm.assessPlan, "approvalUserId", $$v)
                        },
                        expression: "assessPlan.approvalUserId",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "col-12" },
                  [
                    _c("c-textarea", {
                      attrs: {
                        editable: _vm.editable,
                        disabled: true,
                        autogrow: "",
                        label: "상세내용",
                        name: "remark",
                      },
                      model: {
                        value: _vm.assessPlan.remark,
                        callback: function ($$v) {
                          _vm.$set(_vm.assessPlan, "remark", $$v)
                        },
                        expression: "assessPlan.remark",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "col-12" },
                  [
                    _c("c-upload", {
                      staticClass: "q-pt-md",
                      attrs: { attachInfo: _vm.attachInfo, editable: false },
                    }),
                  ],
                  1
                ),
              ]),
            ],
            2
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }